<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12">
          <b-card-group>
            <b-card no-body class="p-3">
              <b-card-body>
                <div
                  class="text-muted text-center d-flex justify-content-center"
                >
                  <div id="player" class="safieStreamingPlayer"></div>
                </div>
                <!--
                <div class="text-muted text-center">
                  <input type="button" value="Play" @click="play" />
                  <input type="button" value="Pause" @click="pause" />
                </div>
                -->
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LiveCamera',
  data() {
    return {
      // safieStreamingPlayerインスタンス
      safieStreamingPlayer: null,
      // SafieデバイスID
      safieDeviceId: '',
      // SafieToken
      safieToken: '',
    }
  },
  async beforeCreate() {},
  async mounted() {
    // document.addEventListener("DOMContentLoaded",
    window.addEventListener("load",
      () => {
        this.initialize()
      }
    )
  },
  beforeDestroy() {
  },
  methods: {
    async initialize() {
      // 遷移パラメータを取得
      this.safieToken = this.$router.currentRoute.query.safieToken
      this.safieDeviceId = this.$router.currentRoute.query.safieDeviceId
      try {
        const result = await Safie.Auth.initialize()
        console.log(result.tokenType)
      } catch (error) {
        console.log(error)
        await Safie.Auth.setToken(
          this.safieToken,
          Safie.Auth.TokenType.AccessToken
        )
      }

      try {
        const element = document.getElementById('player')
        this.safieStreamingPlayer = new Safie.Player.StreamingPlayer(element)
        this.safieStreamingPlayer.deviceId = this.safieDeviceId
        this.safieStreamingPlayer.play()
      } catch (error) {
        console.log(error)
      }
    },

    async play() {
      this.safieStreamingPlayer.play()
    },
    async pause() {
      this.safieStreamingPlayer.pause()
    },
  },
}
</script>

<style scoped>
.safieStreamingPlayer {
  width: 640px;
  height: 480px;
  display: block;
}
</style>
